export default {
	text: "{changedBy} updated the value of this KR from {from} to {to}",
};
